import React from 'react';
import TableEmptyState from '@shared/components/TableEmptyState';
import TableNoSearchResults from '@shared/components/TableNoSearchResults';

type MetricsEmptyStateProps = {
  searchValue: string;
  resetSearch: () => void;
};

const ArtifactVersionAssetsEmptyState: React.FC<MetricsEmptyStateProps> = ({
  searchValue,
  resetSearch,
  ...props
}) => {
  if (searchValue) {
    return (
      <TableNoSearchResults
        buttonText="Clear search"
        clickHandler={resetSearch}
        colSpan="10"
      />
    );
  }

  return (
    <TableEmptyState
      pictureHeight="0"
      pictureWidth="0"
      materialProps={props}
      label={'No assets for this version.'}
    />
  );
};

export default ArtifactVersionAssetsEmptyState;
